'use client'
import { FC } from 'react'
import { Button, ButtonProps } from '@/root/ui/tuuleliinid'
import { BottomArrowIcon } from '@/root/ui/shared'
import { useGetTranslations, useCustomRouter } from '@/root/shared-hooks'
import { APP_ROUTES } from '@/root/shared-consts'

interface SelectTicketButtonProps extends ButtonProps {
  packages: Array<string>
  sailRefIds: Array<number>
}

export const SelectTicketButton: FC<SelectTicketButtonProps> = ({ disabled, packages, sailRefIds }) => {
  const { getTranslation } = useGetTranslations()
  const { locale, push } = useCustomRouter()

  const baseUrl = `${APP_ROUTES.selectTickets}`
  const packagesPath = `${packages.join(',')}`
  const refIdPath = `${sailRefIds.join(',')}`

  const url = `/${locale}${baseUrl}/${packagesPath}/${refIdPath}`

  const onGoToSelectTicket = () => push(url)

  return (
    <Button
      variant="contained"
      className="order-first flex h-16 w-full max-w-96 items-center justify-between lg:order-last"
      disabled={disabled}
      onClick={onGoToSelectTicket}
      data-testid="go-to-next"
    >
      <p className="-ms-2 text-sm font-normal lowercase opacity-50">{getTranslation('continueLabel')}</p>
      <div className="xxs:gap-4 -me-2 flex gap-3">
        <p className="xxs:text-2xl text-lg uppercase">{getTranslation('selectTicketLabel')}</p>
        <BottomArrowIcon color="white" width={16} ignoreRtl className="ltr:-mt-1 ltr:-rotate-90 rtl:rotate-90" />
      </div>
    </Button>
  )
}
